var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToiletPaperBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.981 0C74.978 0 31.977 86 31.977 192V364.125C31.977 405.25 22.226 426.875 0.85 491C-2.65 501.25 5.1 512 15.976 512H296.863C310.739 512 322.864 503.25 327.239 490.125C340.115 451.625 351.99 417.75 351.99 364.125V192C351.99 108.375 375.616 38.5 412.493 0H127.981ZM479.996 0C426.994 0 383.992 86 383.992 192C383.992 298 426.994 384 479.996 384S576 298 576 192C576 86 532.998 0 479.996 0ZM479.996 256C462.37 256 447.994 227.375 447.994 192S462.37 128 479.996 128C497.622 128 511.997 156.625 511.997 192S497.622 256 479.996 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletPaperBlank);
export default __webpack_public_path__ + "static/media/toilet-paper-blank.703e765bd9c11824391b20ac3a5ad14b.svg";
export { ForwardRef as ReactComponent };